import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
/* --- import Components ----*/
import { Sentence, FormTitle, FormSubtitle } from 'src/components/Typography';
/* --- import Styles ----*/
import { mediaQueries } from 'src/style/breakpoints';
import { useMediaQueries } from 'src/utils/MediaQueries';

const FormIntroText = ({ selectedEvent, formEndOfPage, noPhoto, modal }) => {
  const mqs = useMediaQueries();

  return (
    <div
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
      }}
    >
      {!formEndOfPage && (
        <FormTitle modal={modal}>
          Réservez votre place pour la prochaine réunion d'information
          {selectedEvent ? ',' : '.'}
          <br></br>
          {selectedEvent && `le ${selectedEvent.date} à ${selectedEvent.time}`}
        </FormTitle>
      )}
      {!modal && (
        <div
          css={{
            display: 'flex',
            gap: formEndOfPage ? 20 : 40,
            alignItems: 'center',
            flexDirection: formEndOfPage ? 'column-reverse' : 'row',
            [mediaQueries.tabletLandscapeUp]: {
              flexDirection: 'row',
            },
            [mediaQueries.desktopUp]: {
              gap: 10,
              width: '100%',
            },
            [mediaQueries.phoneOnly]: {
              justifyContent: 'center',
              width: '100%',
            },
          }}
        >
          <div
            css={{
              display: 'flex',
              flexDirection: 'column',
              [mediaQueries.phoneOnly]: {
                alignItems: 'center',
                gap: 20,
              },
            }}
          >
            {formEndOfPage ? (
              <FormSubtitle>
                Posez toutes vos questions, en direct,{mqs.desktopUp ? ' ' : <br></br>}à Xavier
                Colombel, fondateur du Reacteur
                {selectedEvent ? ',' : '.'}
                {mqs.desktopUp ? ' ' : <br></br>}
                {selectedEvent && `le ${selectedEvent.date} à ${selectedEvent.time}`}
              </FormSubtitle>
            ) : (
              <FormSubtitle>
                L’événement qui peut changer votre avenir&nbsp;!
                {selectedEvent && formEndOfPage ? ', ' : null}
                {mqs.phoneOnly ? <br></br> : ' '}
                {selectedEvent &&
                  formEndOfPage &&
                  `le\u00A0${selectedEvent.date} à\u00A0${selectedEvent.time}.`}
              </FormSubtitle>
            )}

            {!noPhoto && !formEndOfPage && (
              <div
                css={{
                  height: '100px',
                  width: '100px',
                  displayFlex: 'center',
                  justifyContent: 'center',
                  [mediaQueries.tabletPortraitUp]: {
                    display: 'none',
                  },
                }}
              >
                <StaticImage
                  src="../../../src/data/images/2023_Xavier.jpg"
                  alt="Le Reacteur - portrait de Xavier Colombel"
                  css={{
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    borderRadius: '50%',
                    height: 100,
                    width: 100,
                    boxShadow: '0px 5px 10px rgba(0, 0, 0, 0.2)',
                    overflow: 'hidden',
                  }}
                />
              </div>
            )}
            {!formEndOfPage && (
              <Sentence
                css={{
                  fontWeight: 400,
                  [mediaQueries.phoneOnly]: {
                    textAlign: 'center',
                  },
                }}
              >
                Le fondateur du Reacteur, Xavier Colombel,<br></br>répond à toutes vos questions,
                sans filtre, sur<br></br>nos formations au Développement Web et Mobile.
              </Sentence>
            )}
          </div>

          {!noPhoto && (
            <div
              css={{
                height: '100px',
                width: '100px',
                [mediaQueries.phoneOnly]: {
                  display: formEndOfPage ? null : 'none',
                },
              }}
            >
              <StaticImage
                src="../../../src/data/images/2023_Xavier.jpg"
                alt="Le Reacteur - portrait de Xavier Colombel"
                css={{
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center',
                  borderRadius: '50%',
                  height: 100,
                  width: 100,
                  boxShadow: '0px 5px 10px rgba(0, 0, 0, 0.2)',
                  overflow: 'hidden',
                }}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default FormIntroText;
